<template>
	<div>
			<Window ref="Window" :bg="bg">
					<!-- 头部开始 -->
					<div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E">
						<button @click="setting" :title="$t('me8',['个人信息'])" type="button">
								<Icon name="edit"  class="w1x h1x" :sizeBase="'m'"/>
						</button>
						<button @click="refresh" :title="$t('cmd7',['刷新'])" type="button">
								<Icon name="refresh" class="w1x h1x" :sizeBase="'m'"/>
						</button>
					</div>
					<div slot="head" class="cb">
					<div class="dpIB vaM_E"> 
						<div class="w4x h4x dpIB"><Logo customClass='w4x h4x mr1x' :Logourl='userInfo.userInfo.photo' :LogoType="'person'"/></div>
						<span class="fs14x ml05x"> {{userInfo.userInfo.name}}</span>
					</div>
				<div class="posR mt1x">
					<div class="dpIB_E dpIB fs10x">
						<div class="tableSys cSub pr1x_E">
							<div>{{getLanguageStr('word100','激活状态')}}</div>
							<div>{{getLanguageStr('word90','角色')}}</div>
							<div>{{getLanguageStr('word1321',['部门'])}}</div>
							<div>{{getLanguageStr('word88',['电话'])}}</div>
							<div>{{getLanguageStr('word68',['邮箱'])}}</div>
							<div>{{getLanguageStr('word1520',['用户名'])}}</div>
							<div>{{getLanguageStr('manage226',['最后登录时间'])}}</div>
						</div>
						<div class="tableSys mt05x pr1x_E">
							<div>{{2 == userInfo.userInfo.status ? $t("word93",["已激活"]) : $t("word94",["未激活"])}} <StatusIco :id='userInfo.userInfo.status' :type="'statusUser'" class="statueIcon fs08x"></StatusIco></div>
							<div>{{getTypeText(userInfo.orgUser.roleId,'roleType')?getTypeText(userInfo.orgUser.roleId,'roleType'):userInfo.roleName}}</div>
							<div>{{userInfo.groupName?userInfo.groupName:'--'}}</div>
							<div>{{userInfo.userInfo.phoneNumber?userInfo.userInfo.phoneNumber:'--'}}</div>
							<div>{{userInfo.userInfo.email?userInfo.userInfo.email:'--'}}</div>
							<div>{{userInfo.userInfo.username?userInfo.userInfo.username:'--'}}</div>
							<div>{{timeFormat(userInfo.userInfo.lastLoginTime,'inc','%Y/%m/%d %H:%M')}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 头部结束end -->
			<div class='bgContent mt1x pl1x pt1x cSub fSub_E' fillheight="lastHeight">
				<div class="w12x h9x taC boxR-light functionLiner curP tra-fast" v-permissions="'A/B/A1'" @click='locationTo' onclick="statistic('A51','A5102')">
					<div class='pb1x pt1x cSub'>
						<Icon name="solarEnergy" class="w4x h4x" :sizeBase="'xs'"/><br/>
					</div>
					{{getLanguageStr('phrase688','查看授权给该成员的电站')}}
				</div>
			</div>
		</Window>
	</div>
</template>
<script>
import * as lib from '@/util/lib'
import Window from '@/components/common/ui/WindowForView.vue'
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import StatusIco from '@/components/common/ui/StatusIco'
import InputText from '@/components/common/ui/InputText'
import { getLanguageStr } from '@/util/language'
import Logo from '@/components/common/ui/Logo.vue';
import {getUserInfo} from '@/api/login.js'
export default {
	name: 'myPage',
	components: {
		Loading,
		NoResult,
		Window,
		StatusIco,
		InputText,
		Logo
	},
	props: {
		bg: {
				// 是否显示遮罩背景
				type: Boolean,
				default: false
		}
	},
	data () {
		return {
			userInfo: {
				roleName: null,
        groupName: null,
        orgUser:{
          roleId:''
        },
				userInfo: {
					name: null,
						phoneNumber: null,
						email: null,
						lastLoginTime: null,
						username: null,
						status: 1
				}
			}
		}
	},
	computed: {},
	methods: {
		getLanguageStr,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		locationTo () {
				this.$router.push({name: '/maintain/plant', query: {id: this.userInfo.userInfo.id, name: this.userInfo.userInfo.name}})
				this.hide();
				// if (lib.doPermissions('A/B/A1')) {
			// 		this.$router.push({name: '/maintain/plant', query: {id: this.userInfo.userInfo.id, name: this.userInfo.userInfo.name}})
			// 		this.$router.go(0)
				// } else {
			// 		this.$notify(getLanguageStr('phrase697', '你没有运维板块权限，无法执行跳转'))
				// }
		},
		show(id){
			statistic('A51','A5101')
			this.$refs.Window.loadStatusAction(true);
			this.$refs.Window.show({end:()=>{
				getUserInfo().then(res => {
          this.userInfo = res
					this.$refs.Window.loadStatusAction(false)
			 	});
			}});
		},
		hide () {
			this.$refs.Window.hide()
		},
		refresh () {
			this.$refs.Window.loadStatusAction(true)
			getUserInfo().then(res => {
				this.userInfo = res
				this.$refs.Window.loadStatusAction(false)
			})
		},
		setting () {
				this.$emit('setting')
				this.$refs.Window.hide()
		}
	},
	mounted () {
	}
}
</script>
<style lang="scss" scoped>
//@import '~@/style/definition.scss';

.window > .body {
	padding-bottom: 0;
}
// .bgContent{background-color: $bgGray}
.head {
	background: #fff;
}
.statueIcon {
	vertical-align: middle;
	margin: -3px 5px 0 0;
}
.statueIcon :deep(.dvStatus) {
	width: 1.2em;
	height: 1.2em;
}
button::-moz-focus-inner {
	border: 0;
}
.dropList {
	background: #fff;
	width: 9em;
	left: -2em;
	a {
		color: #666;
		padding-right: 1em;
	}
	a:hover {
		background-color: rgba(0, 0, 0, 0.05);
		color: #ff595f;
	}
}

.functionLiner:hover{fill:#fff;min-height:2em;border-radius:$radiusLight;background-image:linear-gradient(135deg,rgba($mainColor,.3),$mainColor);position:relative;overflow:hidden;line-height:1;text-align:center;box-shadow:0 0 .5em rgba($mainColor,.5);color:$mainColorFont;
//	&.functionBtn-lightRadius{border-radius:$radiusLight;}
//	&.functionBtn-xl{padding:.8em 3em;}
//	&.functionBtn-m{padding:{top:.5em;right:1em;bottom:.5em;left:1em;};}
//	&.functionBtn-s{height:2.5em;line-height:2.5em;padding:{left:1em;right:1em;};}
//	&.functionBtn-xs{padding:0;}
}
</style>



// WEBPACK FOOTER //
// src/components/common/account/ViewDetail.vue